module.exports = __webpack_public_path__ + "img/天啊.20e61299.png";